import React, { useState } from "react";
import {
  Paper,
  Grid,
  Typography,
  Divider,
  Button,
  IconButton,
  makeStyles,
  Box,
  TextField,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import DoneIcon from "@material-ui/icons/Done";
import { labelsColors } from "../../../core/redux/dataMap/label";
import { red } from "@material-ui/core/colors";

export default function LabelEditCard({
  onClose,
  onEditLabel,
  label,
  onDeleteLabel,
}) {
  const [newName, setNewName] = useState(label.name);
  const [selectedColor, selectColor] = useState({ color: label.color });
  const classes = useStyles();
  const colors = Object.keys(labelsColors);

  const handleCreateLabel = () => {
    onEditLabel({ ...label, name: newName, color: selectedColor });
    onClose(true);
  };

  const handleDeleteLabel = () => {
    onDeleteLabel(label.id);
    onClose(true);
  };

  return (
    <Paper>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item md={10} xs={10}>
          <Typography className={classes.title}>Labels</Typography>
        </Grid>
        <Grid item md={2}>
          <IconButton onClick={() => onClose(false)} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <Box p={1}>
        <TextField
          variant="outlined"
          value={newName}
          onChange={(e) => {
            setNewName(e.target.value);
          }}
          fullWidth
          label="Name"
          size="small"
        />

        <Typography className={classes.colorsTitle}>Select a color</Typography>
        <Box pt={1}>
          <Grid container spacing={1}>
            {colors.map((color) => (
              <Grid item xs={2} key={color}>
                <Color
                  color={labelsColors[color]}
                  onClick={() => selectColor(color)}
                >
                  {selectedColor === color ? <DoneIcon size="small" /> : null}
                </Color>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Divider />

      <Grid container justify="space-between" className={classes.buttons}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateLabel}
          >
            <Typography className={classes.buttonText}>Update</Typography>
          </Button>
        </Grid>
        <Grid item>
          <ColorButton variant="contained" onClick={handleDeleteLabel}>
            <Typography className={classes.buttonText}>Delete</Typography>
          </ColorButton>
        </Grid>
      </Grid>
    </Paper>
  );
}

export const Color = styled.div`
  background-color: ${(props) => props.color};
  width: 100%;
  height: 27px;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    filter: brightness(85%);
  }
  white-space: normal;
  display: flex;
  place-content: center;
  place-items: center;
`;

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "100px 0",
    padding: "5px",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "14px",
    color: "#9A9A9A",
    textAlign: "center",
    width: "100%",
  },
  colorsTitle: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "10px",
    lineHeight: "9px",
    color: "#5F5F5F",
    marginTop: "10px",
  },
  buttonText: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontSize: "13px",
    lineHeight: "14px",
    textAlign: "center",
    color: "inherit",
    width: "100%",
    textTransform: "none",
  },
  buttons: {
    padding: "10px",
  },
}));
